import React, { useMemo, useState } from "react";

// A filterable list of wind farms with an ON/OFF pill per row, shared by the
// user-handling edit panel (wind farm access) and the Lightning subscription
// page. `assignedIds` is a Set of wind farm ids that are ON; `onToggle(wf)`
// must return a promise that resolves when the change is persisted.
export default function WindfarmToggleList({ windfarms, assignedIds, onToggle, loading = false, countLabel = "assigned" }) {
  const [search, setSearch] = useState("");
  const [busyId, setBusyId] = useState(null);

  const visible = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return windfarms;
    return windfarms.filter((wf) => wf.name.toLowerCase().includes(q) || (wf.customer || "").toLowerCase().includes(q));
  }, [windfarms, search]);

  function toggle(wf) {
    if (busyId || loading) return;
    setBusyId(wf.id);
    Promise.resolve(onToggle(wf)).finally(() => setBusyId(null));
  }

  return (
    <div className="windfarm-toggle-list">
      <div className="section-toolbar">
        <input className="search-input" placeholder="Filter wind farms…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <span className="count-label">{loading ? "Loading…" : `${assignedIds.size} ${countLabel}`}</span>
      </div>
      <div className="windfarm-list">
        {visible.map((wf) => {
          const on = assignedIds.has(wf.id);
          return (
            <div key={wf.id} className={`windfarm-row ${on ? "assigned" : ""}`} onClick={() => toggle(wf)}>
              <div className="wf-info">
                <strong>{wf.name}</strong>
                <span className="wf-customer">{wf.customer}</span>
              </div>
              <span className={`wf-toggle ${on ? "on" : "off"} ${busyId === wf.id ? "busy" : ""}`}>{on ? "ON" : "OFF"}</span>
            </div>
          );
        })}
        {visible.length === 0 && <p className="empty-state">No wind farms match your search.</p>}
      </div>
    </div>
  );
}
